/* tc-consent.js — カートの利用規約同意ゲート（2026-07-22）
   委譲イベント方式: カートドロワーのfetch再描画後もリスナーが生きる。
   同意チェックボックスが同一スコープに存在する場合のみチェックアウトを止める。 */
(function () {
  'use strict';
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.cart__checkout-button') : null;
      if (!btn) return;
      var scope =
        btn.closest('.drawer__footer') ||
        btn.closest('.cart__footer') ||
        btn.closest('form') ||
        document;
      var box = scope.querySelector('[data-tc-consent-box]');
      if (!box) return;
      var err = scope.querySelector('[data-tc-consent-error]');
      if (!box.checked) {
        e.preventDefault();
        e.stopPropagation();
        if (err) err.hidden = false;
        box.focus();
      } else if (err) {
        err.hidden = true;
      }
    },
    true
  );
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches('[data-tc-consent-box]')) return;
    var scope = e.target.closest('.tc-terms-consent');
    var err = scope && scope.querySelector('[data-tc-consent-error]');
    if (err && e.target.checked) err.hidden = true;
  });
})();
